import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "../store";
import { getToken } from "@/utils/auth";
const { getRequestErrorMessage } = require("@/utils/requestError");

// 手机端英文页路由前缀。这里读 location 而不是 router，
// 是为了避免 request.js 与 router 之间产生循环依赖。
function isMobileRoute() {
  return (window.location.hash || "").indexOf("#/m/") === 0;
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // api的base_url
  timeout: 15000000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    const config = response.config || {};
    const bypassCodes = config.bypassErrorCodes || [];
    if (bypassCodes.indexOf(res.code) !== -1) {
      return response.data;
    }
    if (res.code !== 200) {
      // 手机端英文页自行展示英文错误，不弹中文全局 toast
      const silent = config.silentError || isMobileRoute();
      if (!silent) {
        Message({
          message: res.message,
          type: "error",
          duration: 3 * 1000,
        });
      }

      // 401:未登录;
      if (res.code === 401) {
        if (isMobileRoute()) {
          // 手机页：不弹中文确认框，直接清登录态回英文登录页
          store.dispatch("FedLogOut").then(() => {
            localStorage.removeItem("loginUserInfo");
            window.location.hash = "#/m/login";
            window.location.reload();
          });
        } else {
          MessageBox.confirm("你已被登出，可以取消继续留在该页面，或者重新登录", "确定登出", {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            store.dispatch("FedLogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          });
        }
      }
      return Promise.reject(res.message);
    } else {
      return response.data;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    if (isMobileRoute()) {
      // HTTP 层 401（无效/过期 token 由 Spring Security 直接以 401 状态码返回）
      if (error.response && error.response.status === 401) {
        store.dispatch("FedLogOut").then(() => {
          localStorage.removeItem("loginUserInfo");
          window.location.hash = "#/m/login";
          window.location.reload();
        });
      }
    } else {
      Message({
        message: getRequestErrorMessage(error),
        type: "error",
        duration: 3 * 1000,
      });
    }
    return Promise.reject(error);
  }
);

export default service;
